import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-order-details-detail',
    templateUrl: './order-details-detail.component.html',
    imports: [TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OrderDetailsDetail {
    public isDistributor = input<boolean>(false);
    public distributorName = input<string | null>(null);
    public isCprContract = input<boolean>(false);
    public monthsOfInventory = input<number | null>(null);
    public additionalEmails = input<string[]>([]);

    private translate = inject(TranslateService);

    protected distributorDisplay = computed(() => {
        if (this.isDistributor()) {
            const name = this.distributorName();
            return name ? `${this.translate.instant('common.yes')} — ${name}` : this.translate.instant('common.yes');
        }
        return this.translate.instant('common.no');
    });

    protected cprDisplay = computed(() =>
        this.isCprContract() ? this.translate.instant('common.yes') : this.translate.instant('common.no')
    );

    protected additionalEmailsDisplay = computed(() => this.additionalEmails().join(', ') || '');
}
